export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ21.2d0932a4.mp3";